module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-arrow_r-f93c8af919d45a6e82738539cbea5efc.svg";